import {AssetPartLocation, RollerParts, StationParts} from '@domain/kiln-monitoring'

import {
  BuildDriveLocationsInput,
  BuildKilnShellLocationsInput,
  BuildStationLocationsInput,
  OpenDriveParts,
  PinionParts,
  DriveParts,
  KilnShellParts
} from './KilnParts.types'

export const buildDriveLocations = ({id, position}: BuildDriveLocationsInput) => {
  const girthGearNumber = position === 'bottom' ? 1 : 6
  const bottomDriveStart = position === 'double' ? 7 : 2
  const bottomDriveOffsetY = position === 'bottom' ? -60 : 0

  const locations: AssetPartLocation[] = [
    {
      id: `${id}_${OpenDriveParts.GIRTH_GEAR}`,
      label: 'Girth gear',
      locationNumber: girthGearNumber,
      x: 90,
      y: 140 + bottomDriveOffsetY
    }
  ]

  if (position === 'top' || position === 'double') {
    locations.push(
      {
        id: `${id}_${OpenDriveParts.DRIVE_TOP}_${DriveParts.MOTOR}`,
        label: 'Motor',
        locationNumber: 1,
        x: 10,
        y: 3
      },
      {
        id: `${id}_${OpenDriveParts.DRIVE_TOP}_${DriveParts.GEARBOX}`,
        label: 'Gearbox',
        locationNumber: 2,
        x: 10,
        y: 48
      },
      {
        id: `${id}_${OpenDriveParts.DRIVE_TOP}_${DriveParts.PINION}_${PinionParts.BEARING_LEFT}`,
        label: 'Bearing',
        locationNumber: 3,
        x: 50,
        y: 24
      },
      {
        id: `${id}_${OpenDriveParts.DRIVE_TOP}_${DriveParts.PINION}_${PinionParts.PINION}`,
        label: 'Pinion',
        locationNumber: 4,
        x: 90,
        y: 35
      },
      {
        id: `${id}_${OpenDriveParts.DRIVE_TOP}_${DriveParts.PINION}_${PinionParts.BEARING_RIGHT}`,
        label: 'Bearing',
        locationNumber: 5,
        x: 150,
        y: 48
      }
    )
  }

  if (position === 'bottom' || position === 'double') {
    locations.push(
      {
        id: `${id}_${OpenDriveParts.DRIVE_BOTTOM}_${DriveParts.MOTOR}`,
        label: 'Motor',
        locationNumber: bottomDriveStart + 4,
        x: 10,
        y: 300 + bottomDriveOffsetY
      },
      {
        id: `${id}_${OpenDriveParts.DRIVE_BOTTOM}_${DriveParts.GEARBOX}`,
        label: 'Gearbox',
        locationNumber: bottomDriveStart + 3,
        x: 10,
        y: 255 + bottomDriveOffsetY
      },
      {
        id: `${id}_${OpenDriveParts.DRIVE_BOTTOM}_${DriveParts.PINION}_${PinionParts.BEARING_LEFT}`,
        label: 'Bearing',
        locationNumber: bottomDriveStart + 2,
        x: 50,
        y: 280 + bottomDriveOffsetY
      },
      {
        id: `${id}_${OpenDriveParts.DRIVE_BOTTOM}_${DriveParts.PINION}_${PinionParts.PINION}`,
        label: 'Pinion',
        locationNumber: bottomDriveStart + 1,
        x: 90,
        y: 265 + bottomDriveOffsetY
      },
      {
        id: `${id}_${OpenDriveParts.DRIVE_BOTTOM}_${DriveParts.PINION}_${PinionParts.BEARING_RIGHT}`,
        label: 'Bearing',
        locationNumber: bottomDriveStart,
        x: 150,
        y: 255 + bottomDriveOffsetY
      }
    )
  }

  locations.sort((a, b) => a.locationNumber - b.locationNumber)
  return locations
}

export const buildStationLocations = ({id, thrustRollerPosition}: BuildStationLocationsInput) => {
  const locations: AssetPartLocation[] = [
    {
      id: `${id}_${StationParts.SUPPORT_ROLLER_TOP}_${RollerParts.SUPPORT_ROLLER_BEARING_LEFT}`,
      label: 'Bearing',
      locationNumber: 1,
      x: 0,
      y: 52
    },
    {
      id: `${id}_${StationParts.SUPPORT_ROLLER_TOP}_${RollerParts.SUPPORT_ROLLER_DEFLECTOR}`,
      label: 'Deflection',
      locationNumber: 2,
      x: 50,
      y: 0
    },
    {
      id: `${id}_${StationParts.SUPPORT_ROLLER_TOP}_${RollerParts.SUPPORT_ROLLER_BEARING_RIGHT}`,
      label: 'Bearing',
      locationNumber: 3,
      x: 100,
      y: 52
    },
    {
      id: `${id}_${StationParts.SUPPORT_ROLLER_TOP}_${RollerParts.SUPPORT_ROLLER_ROLLER}`,
      label: 'Roller',
      locationNumber: 4,
      x: 50,
      y: 50
    },
    {
      id: `${id}_${StationParts.TYRE}`,
      label: 'Tyre',
      locationNumber: 5,
      x: 50,
      y: 140
    },
    {
      id: `${id}_${StationParts.SUPPORT_ROLLER_BOTTOM}_${RollerParts.SUPPORT_ROLLER_ROLLER}`,
      label: 'Roller',
      locationNumber: 6,
      x: 50,
      y: 230
    },
    {
      id: `${id}_${StationParts.SUPPORT_ROLLER_BOTTOM}_${RollerParts.SUPPORT_ROLLER_BEARING_LEFT}`,
      label: 'Bearing',
      locationNumber: 7,
      x: 0,
      y: 228
    },
    {
      id: `${id}_${StationParts.SUPPORT_ROLLER_BOTTOM}_${RollerParts.SUPPORT_ROLLER_DEFLECTOR}`,
      label: 'Deflection',
      locationNumber: 8,
      x: 50,
      y: 280
    },
    {
      id: `${id}_${StationParts.SUPPORT_ROLLER_BOTTOM}_${RollerParts.SUPPORT_ROLLER_BEARING_RIGHT}`,
      label: 'Bearing',
      locationNumber: 9,
      x: 100,
      y: 228
    }
  ]

  if (thrustRollerPosition === 'right') {
    locations.push({
      id: `${id}_${StationParts.THRUST_ROLLER}`,
      label: 'Thrust Unit',
      locationNumber: 10,
      x: 5 + 92,
      y: 140
    })
  } else if (thrustRollerPosition === 'left') {
    locations.push({
      id: `${id}_${StationParts.THRUST_ROLLER}`,
      label: 'Thrust Unit',
      locationNumber: 10,
      x: 5,
      y: 140
    })
  }

  locations.sort((a, b) => a.locationNumber - b.locationNumber)
  return locations
}

export const buildKilnShellLocations = ({id}: BuildKilnShellLocationsInput) => {
  const locations: AssetPartLocation[] = [
    {
      id: `${id}_${KilnShellParts.KILN_SHELL}`,
      label: 'Kiln Shell',
      locationNumber: 1,
      x: 600,
      y: 40
    }
  ]

  locations.sort((a, b) => a.locationNumber - b.locationNumber)
  return locations
}
